import axios from 'axios';

let url;
const { token } = localStorage;

// process.env.SERVERMODE == 'local' ? '/web/webroot' : ''
if (process.env.SERVERMODE === 'local') {
  url = process.env.CLIENT_API_LOCAL_DOMAINNAME;
}
if (process.env.SERVERMODE === 'uat') {
  url = process.env.CLIENT_API_UAT_DOMAINNAME;
}
if (process.env.SERVERMODE === 'production') {
  url = process.env.CLIENT_API_PRODUCTION_DOMAINNAME;
}

const apiDefaultWithoutToken = axios.create({
  baseURL: url,
  headers: { 'Content-Type': 'application/json' },
});

const apiDefaultWithoutTokenWithUrlencodedType = axios.create({
  baseURL: url,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
  },
});

const apiDefaultWithoutTokenWithUrlencodedTypeAcceptAll = axios.create({
  baseURL: url,
  headers: {
    Accept: '*/*',
    'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
  },
});

const apiDefaultWithToken = axios.create({
  baseURL: url,
  headers: {
    Accept: 'application/json',
    Authorization: `Bearer ${token}`,
    'content-type': 'application/x-www-form-urlencoded',
  },
});

const apiDefaultWithImage = axios.create({
  baseURL: url,
  headers: {
    Accept: 'image/avif,image/webp,image/apng,image/svg+xml,image/*,*/*;q=0.8',
    'content-type': 'image/jpeg;charset=UTF-8',
  },
});

export {
  apiDefaultWithoutToken,
  apiDefaultWithToken,
  apiDefaultWithoutTokenWithUrlencodedType,
  apiDefaultWithoutTokenWithUrlencodedTypeAcceptAll,
  apiDefaultWithImage,
};
